'use client'

import { twMerge } from '@/lib/classname/twMerge'
import { useIsReactNativeWebView } from '@/lib/react-native/contexts/react-native/ReactNativeProvider.client'
import { useHover } from 'react-aria'

export type ProductCardHoverGroupProps = React.PropsWithChildren<{
  className?: string
  disabled?: boolean
}>

// Tracks hover and exposes it as the `group/product-card` group driving ProductCard's stroke, CTA and stock fade, used standalone by ProductCard or wrapped around SelectableItem in a bundle
export function ProductCardHoverGroup({
  children,
  className,
  disabled,
}: ProductCardHoverGroupProps): React.ReactElement {
  const isInWebView = useIsReactNativeWebView()
  const { hoverProps, isHovered } = useHover({ isDisabled: disabled })

  if (disabled) {
    return <div className={className}>{children}</div>
  }

  return (
    <div
      {...hoverProps}
      className={twMerge('group/product-card', className)}
      data-hovered={(isHovered && !isInWebView) || undefined}
    >
      {children}
    </div>
  )
}
